const sortOptions = [
  'publishedDate',
  'createdAt',
  // 'countEmbeds',
];

const validLanguages       = ['de', 'en', 'pl', 'fr'];
const autoRefreshTime      = 86400;
const featuredChannelIdDev = 781; // ID of the featured channel on DEV
// const featuredChannelIdDev  = 803; // ID of the featured channel on DEV
const featuredChannelId      = 171; // ID of the featured channel on LIVE
const mostViewedChannelIdDev = 959; // ID of the featured channel on DEV
const mostViewedChannelId    = 259; // ID of the featured channel on LIVE
const channelPreviewCount    = 4; // Number of mediaContainers for channel preview
const mobileWidth            = 480;

const portholeProxy    = '//tc-mh-3796-dev.admiralcloud.com/porthole/proxy.html';
const includeAuthToken = false; // Set this to true if mediahub should use auth token

/* >>> DEV <<< Toll Collect MediaHub */
// const mediahubIdDev = 'dbQpUpYerjTd7';
/* >>> DEV <<< Toll Collect MediaHub */
//const mediahubIdDev = 'i7YwhFALZSeY0';
const mediahubIdDev = 'dQSzY8CWrMPUyQUbXhFnNA';

/* >>> CUSTOMER DEV <<< Toll Collect MediaHub */
// const mediahubId = 'hmqBPsFokirY5';
const mediahubId = 'dQSzY8CWrMPUyQUbXhFnNA';

export default {
  sortOptions,
  autoRefreshTime,
  featuredChannelIdDev,
  featuredChannelId,
  mostViewedChannelIdDev,
  mostViewedChannelId,
  channelPreviewCount,
  mediahubIdDev,
  mediahubId,
  mobileWidth,
  portholeProxy,
  includeAuthToken,
  validLanguages,
};



// WEBPACK FOOTER //
// ./src/config.js